// Image preparation matches the Messenger profile editor.
const MAX_AVATAR_BYTES = 650 * 1024;
const MAX_SOURCE_AVATAR_BYTES = 5 * 1024 * 1024;
const ALLOWED_AVATAR_TYPES = new Set(['image/jpeg', 'image/png', 'image/webp']);

function dataUrlBytes(value) {
  const base64 = String(value || '').split(',')[1] || '';
  return Math.floor(base64.length * 0.75);
}

export function prepareTelegramAvatar(file) {
  return new Promise((resolve, reject) => {
    if (!file || !ALLOWED_AVATAR_TYPES.has(file.type) || !file.size || file.size > MAX_SOURCE_AVATAR_BYTES) {
      reject(new Error('Выберите JPG, PNG или WebP размером до 5 МБ.'));
      return;
    }
    const reader = new FileReader();
    reader.onerror = () => reject(new Error('Не удалось прочитать изображение.'));
    reader.onload = () => {
      const image = new Image();
      image.onerror = () => reject(new Error('Telegram не сможет использовать это изображение. Выберите другое.'));
      image.onload = () => {
        const scale = Math.min(1, 800 / Math.max(image.naturalWidth, image.naturalHeight));
        const canvas = document.createElement('canvas');
        canvas.width = Math.max(1, Math.round(image.naturalWidth * scale));
        canvas.height = Math.max(1, Math.round(image.naturalHeight * scale));
        const context = canvas.getContext('2d');
        if (!context) {
          reject(new Error('Не удалось подготовить фото. Выберите другое.'));
          return;
        }
        context.drawImage(image, 0, 0, canvas.width, canvas.height);
        let jpeg = canvas.toDataURL('image/jpeg', 0.86);
        if (dataUrlBytes(jpeg) > MAX_AVATAR_BYTES) jpeg = canvas.toDataURL('image/jpeg', 0.64);
        if (dataUrlBytes(jpeg) > MAX_AVATAR_BYTES) {
          reject(new Error('Фото получилось слишком большим. Выберите изображение попроще.'));
          return;
        }
        resolve(jpeg);
      };
      image.src = String(reader.result || '');
    };
    reader.readAsDataURL(file);
  });
}


export function profileErrorMessage(error) {
  return error?.response?.data?.message || 'Не удалось обновить профиль Telegram. Попробуйте ещё раз.';
}

export function profileAvatar(value) {
  return typeof value === 'string' && value.length <= 1000000
    && /^data:image\/(?:jpeg|png|webp);base64,[A-Za-z0-9+/]+={0,2}$/.test(value) ? value : null;
}
